import { Card, Typography, Box, Divider, Tooltip } from "@mui/material";
import styles from "../devotee.module.scss";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  StyledDateContainer,
  CustomDatePicker,
  CustomCalendarIcon,
  CommonButton,
  HcccCard,
  CustomCalendarTodayOutlinedIcon,
} from "../../common/StyledComponents/StyledFields";
import constants from "../../../config/constants.json";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import EmptyPage from "../../common/emptyPages/emptyPage";
import ToastComponent from "../../common/toastComponent";
import { CustomTooltip } from "../../common/muhurtham/muhurtham";
import { apiRequest, catchErrorMessageHandler } from "../../../infrastructure/backendService";
import { AxiosResponse, AxiosError } from "axios";
import { useNavigate, useParams } from "react-router-dom";
import userAvathar from '../../../assets/userAvathar.png';
import { isNil } from "lodash";
import apiPath from "../../../config/apiPaths.json";
import ToastError from "../../common/toast/toastError";
import ErrorPopup from "../../common/ErrorPopup";

const Reminders: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [remindersList, setRemindersList] = useState<any[]>([]);
  const userName = sessionStorage.getItem("username");

  // const { userName } = useParams();
  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.devoteeSubscriptions}/${userName?.toUpperCase()}`,
      includeToken: true,
    })
      .then((res: AxiosResponse) => {
        setRemindersList(res.data);
      })
      .catch((err: AxiosError) => {
        console.log(err);
        toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
          duration: constants.TOAST_POPUP_DURATION,
        });
      });
  }, []);

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/user/${userName}`);
  }

  const BasicDatePicker = (): React.ReactElement => {
    return (
      <StyledDateContainer>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DateTimePicker"]}>
            <CustomDatePicker
              slots={{
                openPickerIcon: CustomCalendarIcon,
              }}
              slotProps={{
                inputAdornment: {
                  position: "start",
                },
              }}
              format="D MMM YY"
            />
          </DemoContainer>
        </LocalizationProvider>
      </StyledDateContainer>
    );
  };

  const renderEmptyData = () => {
    return (
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            paddingBottom: "18px",
          }}
        >
          <Typography
            sx={{
              color: "#313131",
              fontFamily: "Lato",
              fontSize: "24px",
              fontStyle: "normal",
              fontWeight: 600,
            }}
          >
            Reminders
          </Typography>

          <Box
            sx={{
              marginRight: "0px",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              marginTop: "75px",
            }}
          >
            <EmptyPage
              imgUrl="/images/EmptyReminder.svg"
              typographyText="No Reminders to Show"
              subComponent={<CommonButton onClick={handleNavigate}>Add</CommonButton>}
            />
          </Box>
        </Box>
      </Box>
    );
  };

  const formatDate = (dateString: string): string => {
    const parts = dateString.split('-');
    if (parts.length === 3) {
        return parts[0] + '-' + parts[1]; // mm-dd
    }
    return dateString; // Return the original string if it doesn't match the expected format
};

  const renderWithData = () => {
    return (
      <>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "18px",
          }}
        >
          <Typography className={styles.header}>
            Reminders
          </Typography>
          <CommonButton onClick={handleNavigate}>Add</CommonButton>
        </Box>
        <Box className={styles.contentContainer}>
        {remindersList.map((info) => (
          <Box
            sx={{
              // width: "100%",
              // height: "90px",
              // padding: "0px 15px 16px 0px",
              // marginBottom: "24px",
            }}
            key={info.subscribedEvent}
          >
            <Box sx={{ display: "flex", height: "55px", gap: "1rem" }}>
              <Box className={styles.image}>
                <img src={userAvathar} alt="Image" />
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <CustomTooltip title={info.subscribedEvent} placement="top-start" arrow>
                  <Typography
                    sx={{
                      color: "#313131",
                      fontFamily: "Lato",
                      fontSize: "16px",
                      fontStyle: "normal",
                      fontWeight: 500,
                      // margin: "0px 36px 0px 8px",
                    }}
                  >
                    {info.subscribedEvent.length > 35
                      ? `${info.subscribedEvent.slice(0, 35)}...`
                      : info.subscribedEvent}
                  </Typography>
                </CustomTooltip>
                {!isNil(info.subscriptionDate) ? <Box sx={{ display: "flex" }}>
                <div style={{marginTop: "3px"}}>
                  <CustomCalendarIcon />
                  </div>
                  <div style={{marginLeft: "15px", fontSize: "14px"}}>{formatDate(info.subscriptionDate)}</div>
                </Box> : ""}
              </Box>
            </Box>
            <Divider sx={{ background: "#C1C1C1", marginBottom: "24px" }} />
          </Box>
        ))}
        </Box>
      </>
    );
  };

  return (
    <HcccCard
      className={styles.RemainderLayout}>
      <ToastComponent />
      {remindersList.length === 0 ? (
        <>{renderEmptyData()}</>
      ) : (
        <>{renderWithData()}</>
      )}
    </HcccCard>
  );
};

export default Reminders;
